<script setup lang="ts">
import { computed, reactive } from 'vue'
import type { Option } from '@/types/app'
import DolphinSelector from '@/components/atoms/DolphinSelector.vue'
import { useInternalScenarioChatFormStore } from '../../../form/form'

const props = defineProps<{
  selectedMessageClientOnlyId: string
  selectionIndex: number
  actionIndex: number
}>()

const formStore = reactive(useInternalScenarioChatFormStore())

const value = computed(() => {
  const message =
    formStore.formValues.messages[props.selectedMessageClientOnlyId]
  if (message.selections.type !== 'BasicSelections') {
    throw new Error('message is not basic selections')
  }

  const staffGUID =
    message.selections.basicSelections[props.selectionIndex].actions[
      props.actionIndex
    ].staffGUID

  return staffGUID
})

const assignableStaffs = computed<Option<string>[]>(() => {
  // MEMO: 担当者を複数選択できるようになったら、重複できないようにする

  return formStore.staffs.map(staff => ({
    text: staff.displayName,
    value: staff.guid,
  }))
})

const handleChange = (v: string) => {
  formStore.updateMessage(props.selectedMessageClientOnlyId, draft => {
    if (draft.selections.type !== 'BasicSelections') {
      throw new Error('draft.selections.type is not BasicSelections')
    }

    draft.selections.basicSelections[props.selectionIndex].actions[
      props.actionIndex
    ].staffGUID = v
  })
}
</script>

<template>
  <div :class="$style.form">
    <DolphinSelector
      :options="assignableStaffs"
      :modelValue="value"
      @update:modelValue="$event => handleChange($event as string)"
      :class="$style.selector"
    />
  </div>
</template>

<style lang="scss" module>
.form {
  margin-top: 12px;
}

.selector {
  width: 100%;
}
</style>
